import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../../../utils/rel';
import { getTypeRecommen } from '../../../../../services/api';
import PropTypes from 'prop-types';
import { handleAd } from '../../../../../utils/handleAd';

class HotCars extends React.PureComponent {
    static propTypes = {
        ad: PropTypes.object,
    };
    state = {
        typeAllData: {},
        typeCurData: [],
        type: [
            '热门车',
            '自主车',
            '5-8万',
            '8-12万',
            '12-15万',
            '15-18万',
            '18-25万',
            '25-40万',
            '40-60万',
            '60万以上',
        ],
        hoverIndex: 0,
    };

    async componentDidMount() {
        try {
            const typeData = await getTypeRecommen(1);

            let data = Object.assign(this.state.typeAllData, { type1: typeData });

            this.setState({
                typeAllData: data,
                typeCurData: typeData,
            });

            const { ad } = this.props;

            const callbackFn = await handleAd(ad.hotCar01Ad);
            const callbackFn2 = await handleAd(ad.hotCar02Ad);
            const callbackFn3 = await handleAd(ad.hotCarTxt01Ad);
            const callbackFn4 = await handleAd(ad.hotCarTxt02Ad);

            callbackFn(this.refs.hotCarImg, ad.hotCar01Ad.data);
            callbackFn2(this.refs.hotCarImg, ad.hotCar02Ad.data);
            callbackFn3(this.refs.hotCarTxt, ad.hotCarTxt01Ad.data);
            callbackFn4(this.refs.hotCarTxt, ad.hotCarTxt02Ad.data);
        } catch (e) {
            console.error(e);
        }
        try {
            let typeData = await getTypeRecommen(2);

            let typeAllData = Object.assign(this.state.typeAllData, { type2: typeData });

            let typeOtherData = await getTypeRecommen(3);

            for (let i = 3; i <= this.state.type.length; i++) {
                if (typeOtherData[`interval${i - 2}`]) {
                    typeAllData = Object.assign(this.state.typeAllData, {
                        [`type${i}`]: typeOtherData[`interval${i - 2}`],
                    });
                }
            }
            this.setState({
                typeAllData,
            });
        } catch (e) {
            console.error(e);
        }
    }
    handleMouseEnter = hoverIndex => {
        this.setState({
            hoverIndex,
        });

        const typeIndex = `type${hoverIndex + 1}`;

        if (this.state.typeAllData[typeIndex]) {
            this.setState({
                typeCurData: this.state.typeAllData[typeIndex],
            });
        } else {
            this.getTypeData(hoverIndex + 1);
        }
    };
    getTypeData = async typeid => {
        if (typeid >= 3) {
            let typeData = await getTypeRecommen(3);

            if (typeData[`interval${typeid - 2}`]) {
                let typeAllData = this.state.typeAllData;

                for (let i = 3; i <= this.state.type.length; i++) {
                    typeAllData = Object.assign(this.state.typeAllData, {
                        [`type${i}`]: typeData[`interval${i - 2}`],
                    });
                }

                this.setState({
                    typeAllData,
                    typeCurData: typeAllData[`type${typeid}`],
                });
            }
        } else {
            let typeData = await getTypeRecommen(typeid);

            let typeAllData = Object.assign(this.state.typeAllData, { [`type${typeid}`]: typeData });

            this.setState({
                typeAllData,
                typeCurData: typeAllData[`type${typeid}`],
            });
        }
    };
    render() {
        const { typeCurData, type, hoverIndex, typeAllData } = this.state;

        return (
            <div>
                {typeCurData && typeCurData.length > 0 ? (
                    <div className={styles.fast_search_car}>
                        <div className={styles.fast_search_car_tab} id="auto_p_5">
                            <div className={styles.fsc_b}>
                                <ul className={styles.fsc_btn}>
                                    {type &&
                                        type.map((item, index) => (
                                            <li
                                                key={index}
                                                className={hoverIndex === index ? styles.on : ''}
                                                onMouseEnter={this.handleMouseEnter.bind(this, index)}>
                                                {item}
                                            </li>
                                        ))}
                                </ul>
                                {/* <i /> */}
                            </div>
                            <div className={styles.fsc_con}>
                                <div
                                    className={styles.fsc_c_item}
                                    id="auto_p_5_1"
                                    style={{ display: typeCurData === typeAllData.type1 ? 'block' : 'none' }}>
                                    <ul className={styles.clear} ref="hotCarImg" id="hotCarImg">
                                        {typeCurData &&
                                            typeCurData.length > 0 &&
                                            typeCurData.slice(0, 8).map((item, index) => (
                                                <li className={index === 0 ? styles.t : ''} key={index}>
                                                    <a href={item.serialUrl} target="_blank" rel={rel}>
                                                        <img src={item.logo} alt="" />
                                                        <p className={styles.name}>{item.standardName}</p>
                                                        <p className={styles.guide_price}>{item.guidePrice}万元</p>
                                                    </a>
                                                </li>
                                            ))}
                                    </ul>
                                    <ul className={styles.clear} ref="hotCarTxt" id="hotCarTxt">
                                        {typeCurData &&
                                            typeCurData.length > 8 &&
                                            typeCurData
                                                .slice(8, typeCurData.length > 16 ? 16 : typeCurData.length)
                                                .map((item, index) => (
                                                    <li className={index === 0 ? styles.t : ''} key={index}>
                                                        <a href={item.serialUrl} target="_blank" rel={rel}>
                                                            <p className={styles.name}>{item.standardName}</p>
                                                            <p className={styles.guide_price}>{item.guidePrice}万元</p>
                                                        </a>
                                                    </li>
                                                ))}
                                    </ul>
                                </div>

                                <div
                                    className={styles.fsc_c_item}
                                    style={{ display: typeCurData === typeAllData.type1 ? 'none' : 'block' }}>
                                    <ul className={styles.clear}>
                                        {typeCurData &&
                                            typeCurData.length > 0 &&
                                            typeCurData.slice(0, 8).map((item, index) => (
                                                <li className={index === 0 ? styles.t : ''} key={index}>
                                                    <a href={item.serialUrl} target="_blank" rel={rel}>
                                                        <img src={item.logo} alt="" />
                                                        <p className={styles.name}>{item.standardName}</p>
                                                        <p className={styles.guide_price}>{item.guidePrice}万元</p>
                                                    </a>
                                                </li>
                                            ))}
                                    </ul>
                                    <ul className={styles.clear}>
                                        {typeCurData &&
                                            typeCurData.length > 8 &&
                                            typeCurData
                                                .slice(8, typeCurData.length > 16 ? 16 : typeCurData.length)
                                                .map((item, index) => (
                                                    <li className={index === 0 ? styles.t : ''} key={index}>
                                                        <a href={item.serialUrl} target="_blank" rel={rel}>
                                                            <p className={styles.name}>{item.standardName}</p>
                                                            <p className={styles.guide_price}>{item.guidePrice}万元</p>
                                                        </a>
                                                    </li>
                                                ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    ''
                )}
            </div>
        );
    }
}

export default errorBoundary(HotCars);
